import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import fastLogo from '../assets/F-AST Logo.png';
import './Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPasswordForm, setShowNewPasswordForm] = useState(false);
  const [localError, setLocalError] = useState('');
  
  const { login, completeNewPassword, error, loading } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLocalError('');
    
    try {
      await login(username, password);
    } catch (err) {
      if (err.code === 'NEW_PASSWORD_REQUIRED') {
        setShowNewPasswordForm(true);
      }
    }
  };

  const handleNewPassword = async (e) => {
    e.preventDefault();
    setLocalError('');

    if (newPassword !== confirmPassword) {
      setLocalError('Passwords do not match');
      return;
    }

    if (newPassword.length < 8) {
      setLocalError('Password must be at least 8 characters');
      return;
    }

    try {
      await completeNewPassword(newPassword);
    } catch (err) {
      // Error handled by AuthContext
    }
  };

  if (showNewPasswordForm) {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <img className="login-logo" src={fastLogo} alt="F-AST logo" />
            <p className="login-subtitle">Set New Password</p>
          </div>
          
          <p className="login-message">
            You must set a new password on first login.
          </p>

          <form onSubmit={handleNewPassword} className="login-form">
            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                type="password"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                required
                minLength={8}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                required
                minLength={8}
              />
            </div>

            {(error || localError) && (
              <div className="error-message">
                {localError || (error !== 'NEW_PASSWORD_REQUIRED' ? error : '')}
              </div>
            )}

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? 'Setting Password...' : 'Set Password'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img className="login-logo" src={fastLogo} alt="F-AST logo" />
          <p className="login-subtitle">Forecasting-Accelerated Study Tool</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Email</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          {error && error !== 'NEW_PASSWORD_REQUIRED' && (
            <div className="error-message">{error}</div>
          )}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="login-help">
          Contact your administrator if you need access.
        </p>
      </div>
    </div>
  );
}

export default Login;
